// react
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';

// components
import CreateUnitForm from '@/features/units/forms/CreateUnitForm';
import { showSnackbar } from '@/redux/snackbarSlice';

export const Route = createFileRoute('/$accountId/_user/units/create')({
  component: RouteComponent,
  staticData: { crumb: 'units-gateways-sensors:units.createUnit' },
});

function RouteComponent() {
  const dispatch = useDispatch();
  const { accountId } = useParams({ strict: false });
  const { t } = useTranslation('units-gateways-sensors');
  const navigate = useNavigate();

  const handleBack = () => {
    navigate({ to: '..' });
  };

  const handleSuccess = (unitName: string) => {
    dispatch(
      showSnackbar({
        message: t('units.unitCreatedSuccess', { name: unitName }),
        severity: 'success',
      }),
    );
    handleBack();
  };

  return (
    <PageContainer maxWidth="md" data-testid="unit-create-container">
      <PageHeader title={t('units.newUnit')} disableArrow />
      <CreateUnitForm
        accountId={Number(accountId)}
        onSuccess={handleSuccess}
        onCancel={handleBack}
      />
    </PageContainer>
  );
}
